import { useNavigate } from 'react-router-dom';
import { LayoutGrid, List } from 'lucide-react';

interface Props {
  current: 'list' | 'pipeline';
}

export default function LeadsViewToggle({ current }: Props) {
  const navigate = useNavigate();
  return (
    <div className="inline-flex items-center bg-gray-100 rounded-lg p-1">
      <button
        onClick={() => navigate('/leads')}
        className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          current === 'list'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <List className="h-4 w-4" />
        Lista
      </button>
      <button
        onClick={() => navigate('/leads/pipeline')}
        className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          current === 'pipeline'
            ? 'bg-white text-gray-900 shadow-sm'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        <LayoutGrid className="h-4 w-4" />
        Pipeline
      </button>
    </div>
  );
}
